export const meta = {
  id: 'O00',
  slug: 'administracao',
  title: 'Bem-vindo à Administração',
  description: 'Entenda como o Owner administra a estrutura que sustenta as experiências de Alunos e Mentores no Personagrama.',
  profile: 'owner',
  category: 'comece-aqui',
  type: 'getting-started',
  status: 'published',
  order: 300,
  keywords: ['owner', 'administrador', 'gestão', 'administração', 'personagrama'],
  next: 'O01',
  related: ['M00', 'A00'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Bem-vindo à Administração

O Owner administra a estrutura que permite que Alunos e Mentores utilizem o Personagrama com consistência.

## O que você administra

<Steps>
  <Step title="Pessoas">
    Membros, convites, papéis e associações entre Mentor e Mentorado.
  </Step>
  <Step title="Metodologia">
    Metodologias, Competências, Níveis, Descritores e a base do Diagnóstico.
  </Step>
  <Step title="Conteúdo e desenvolvimento">
    Treinamentos, Jornadas, Formações, participantes, progresso e conclusão.
  </Step>
  <Step title="Operação">
    Planos, Evidências e Mentorias dentro da sua alçada administrativa.
  </Step>
</Steps>

<Callout type="important">
  O Owner herda a visão de Aluno e Mentor, mas deve respeitar as regras de acesso e confidencialidade definidas no Personagrama.
</Callout>
